import { lazy } from 'react'

import { APP_CONSTANTS } from '../repository/constants/constants'
import { AppRouteType } from './../types/router.types'

import guardController from './guards'

export const appRoutes: Array<AppRouteType> = [
  {
    path: APP_CONSTANTS.APP_PATHS.ICONS_PAGE,
    component: lazy(() => import('../pages/icons/Icons.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.ACTIVATE_ACCOUNT,
    component: lazy(() => import('../pages/activate-account/ActivateAccount')),
    guards: [],
  },
  {
    path: '/email',
    component: lazy(() => import('../pages/email-template/email-template')),
    guards: [],
  },

  {
    path: APP_CONSTANTS.APP_PATHS.DASHBOARD_STRIPE,
    component: lazy(() => import('../pages/stripe/Stripe.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.DASHBOARD_STRIPE_SUCCESS,
    component: lazy(() => import('../pages/stripe/Success.page')),
    guards: [],
  },

  {
    path: APP_CONSTANTS.APP_PATHS.HOME_PAGE,
    component: lazy(() => import('../pages/public/home/Home.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.ABOUT,
    component: lazy(() => import('../pages/public/about/About.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.PRICING,
    component: lazy(() => import('../pages/public/pricing/Pricing.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.FEATURES,
    component: lazy(() => import('../pages/public/features/Features.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.SOLUTIONS,
    component: lazy(() => import('../pages/public/solutions/Solutions.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.DEVELOPERS,
    component: lazy(() => import('../pages/public/developers/Developers.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.API_DOCS,
    component: lazy(() => import('../pages/public/api-docs/ApiDocs.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.CONTACT,
    component: lazy(() => import('../pages/public/contact/Contact.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.FAQ,
    component: lazy(() => import('../pages/public/faq/Faq.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.SECURITY,
    component: lazy(() => import('../pages/public/security/Security.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.PARTNERS,
    component: lazy(() => import('../pages/public/partners/Partners.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.BLOG,
    component: lazy(() => import('../pages/public/blog/Blog.page')),
    guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.LOGIN,
    component: lazy(() => import('../pages/auth/login/Login.page')),
    guards: [guardController.verifyAuthRouteAccess],
    // guards: [],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.REGISTER,
    component: lazy(() => import('../pages/auth/register/Register.page')),
    // guards: [],
    guards: [guardController.verifyAuthRouteAccess],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.FORGOT_PASS,
    component: lazy(() => import('../pages/auth/forgot-password/ForgotPassword.page')),
    // guards: [],
    guards: [guardController.verifyAuthRouteAccess],
  },
  {
    path: APP_CONSTANTS.APP_PATHS.SUPER_ADMIN,
    component: lazy(() => import('../pages/super-admin/SuperAdmin.page')),
    guards: [guardController.verifyUserAuthenticity],
    // guards: [],
    nestedComponents: [
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_INDEX,
        component: lazy(() => import('../pages/super-admin/modules/index/SuperIndex.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_SUBSCRIPTION,
        component: lazy(
          () => import('../pages/super-admin/modules/subscription/SuperSubscription.module'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_API_DOC,
        component: lazy(() => import('../pages/super-admin/modules/api-docs/SuperApiDocs.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_SERVICES,
        component: lazy(() => import('../pages/super-admin/modules/services/SuperServices.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_MONITORING,
        component: lazy(() => import('../pages/super-admin/modules/monitoring/SuperMonitoringEnhanced.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_MOMO_MONITORING,
        component: lazy(() => import('../pages/super-admin/modules/monitoring/SuperMonitoring.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_REPORTS,
        component: lazy(() => import('../pages/super-admin/modules/reports/SuperReports.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_ORGANIZATIONS,
        component: lazy(
          () => import('../pages/super-admin/modules/organizations/SuperOrganizationsEnhanced.module'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_ORGANIZATIONS_REQUEST,
        component: lazy(
          () => import('../pages/super-admin/modules/account-request/super-account-request.module'),
        ),
        guards: [],
      },

      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_PROCESS_REFILLS,
        component: lazy(
          () => import('../pages/super-admin/modules/process-refills/ProcessRefills.module'),
        ),
        guards: [],
      },

      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_INDIVIDUALS,
        component: lazy(
          () => import('../pages/super-admin/modules/individuals/SuperIndividualsEnhanced.module'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_WALLET_VERIFICATION,
        component: lazy(
          () => import('../pages/super-admin/modules/wallet-verification/WalletVerification.page'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_FINANCIAL_DASHBOARD,
        component: lazy(
          () => import('../pages/super-admin/modules/financial-dashboard/FinancialDashboard.module'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_SETTINGS,
        component: lazy(() => import('../pages/super-admin/modules/settings/SuperSettings.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_TOP_UP_APPROVAL,
        component: lazy(() => import('../pages/super-admin/modules/top-up-approval/TopUpApproval.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_PAYOUTS,
        component: lazy(() => import('../pages/super-admin/modules/payouts/SuperPayouts.module')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.SUPER_KYC_REVIEW,
        component: lazy(() => import('../pages/super-admin/modules/kyc-review/KYCReview.module')),
        guards: [],
      },
      {
        path: 'bank-accounts',
        component: lazy(() => import('../pages/super-admin/modules/bank-transfer/BankAccountManagement.module')),
        guards: [],
      },
      {
        path: 'bank-transfer-requests',
        component: lazy(() => import('../pages/super-admin/modules/bank-transfer/BankTransferRequests.module')),
        guards: [],
      },
      {
        path: 'bank-transfer/:reference',
        component: lazy(() => import('../pages/super-admin/modules/bank-transfer/BankTransferReview.module')),
        guards: [],
      },
      {
        path: 'fraud-monitoring',
        component: lazy(() => import('../pages/super-admin/modules/fraud-monitoring/FraudMonitoring.module')),
        guards: [],
      },
      {
        path: 'revenue-analytics',
        component: lazy(() => import('../pages/super-admin/modules/revenue-analytics/RevenueAnalytics.page')),
        guards: [],
      },
    ],
  },
  // ORGANIZATION ACCOUNT DASHBOARD - Protected by verifyOrganizationalAccess guard
  // This must come BEFORE the personal dashboard to match first
  {
    path: '/dashboard/organization',
    component: lazy(() => import('../pages/dashboard/OrganizationDashboardEntry.page')),
    guards: [guardController.verifyUserAuthenticity, guardController.verifyOrganizationalAccess],
    nestedComponents: [
      {
        path: '/dashboard/organization',
        component: lazy(() => import('../pages/dashboard/modules/organization/OrganizationDashboard.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/api-keys',
        component: lazy(() => import('../pages/dashboard/modules/organization/APIKeys.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/kyc',
        component: lazy(() => import('../pages/dashboard/modules/organization/KYC.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/payouts',
        component: lazy(() => import('../pages/dashboard/modules/organization/Payouts.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/webhooks',
        component: lazy(() => import('../pages/dashboard/modules/organization/Webhooks.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/transactions',
        component: lazy(() => import('../pages/dashboard/modules/organization/OrganizationTransactions.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/settings',
        component: lazy(() => import('../pages/dashboard/modules/organization/OrganizationSettings.page')),
        guards: [],
      },
      // Balance & Top-Up Routes
      {
        path: '/dashboard/organization/balance/top-up/request',
        component: lazy(() => import('../pages/dashboard/modules/organization/TopUpRequest.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/balance/top-up/history',
        component: lazy(() => import('../pages/dashboard/modules/organization/TopUpHistory.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/balance/top-up/:id',
        component: lazy(() => import('../pages/dashboard/modules/organization/TopUpDetails.page')),
        guards: [],
      },
      // Bank Transfer Routes
      {
        path: '/dashboard/organization/bank-transfer',
        component: lazy(() => import('../pages/dashboard/modules/organization/BankTransferList.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/bank-transfer/initiate',
        component: lazy(() => import('../pages/dashboard/modules/organization/BankTransferInitiate.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/bank-transfer/:reference/upload-proof',
        component: lazy(() => import('../pages/dashboard/modules/organization/BankTransferUploadProof.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/bank-transfer/:reference',
        component: lazy(() => import('../pages/dashboard/modules/organization/BankTransferDetails.page')),
        guards: [],
      },
      // Card Payment Routes
      {
        path: '/dashboard/organization/card-payment',
        component: lazy(() => import('../pages/dashboard/modules/organization/CardPaymentList.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/card-payment/initiate',
        component: lazy(() => import('../pages/dashboard/modules/organization/CardPaymentInitiate.page')),
        guards: [],
      },
      {
        path: '/dashboard/organization/card-payment/:reference',
        component: lazy(() => import('../pages/dashboard/modules/organization/CardPaymentDetails.page')),
        guards: [],
      },
      // Payment routes for organizations
      {
        path: APP_CONSTANTS.APP_PATHS.ORGANIZATION_SINGLE_PAYMENT,
        component: lazy(() => import('../pages/dashboard/modules/organization/payments/OrganizationSinglePayment.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.ORGANIZATION_SINGLE_PAYMENT_SUMMARY,
        component: lazy(() => import('../pages/dashboard/modules/organization/payments/OrganizationSinglePaymentSummary.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.ORGANIZATION_BULK_PAYMENT,
        component: lazy(() => import('../pages/dashboard/modules/organization/payments/OrganizationBulkPayment.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.ORGANIZATION_BULK_PAYMENT_SUMMARY,
        component: lazy(() => import('../pages/dashboard/modules/organization/payments/OrganizationBulkPaymentSummary.page')),
        guards: [],
      },
      // Shared routes that both account types can access
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_PROFILE,
        component: lazy(() => import('../pages/dashboard/modules/profile/DashboardProfile.page')),
        guards: [],
      },
    ],
  },
  // PERSONAL ACCOUNT DASHBOARD - Protected by verifyPersonalAccess guard
  {
    path: APP_CONSTANTS.APP_PATHS.DASHBOARD,
    component: lazy(() => import('../pages/dashboard/DashboardEntry.page')),
    guards: [guardController.verifyUserAuthenticity, guardController.verifyPersonalAccess],
    nestedComponents: [
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_INDEX,
        component: lazy(() => import('../pages/dashboard/modules/index/DashboardIndex.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_USERS,
        component: lazy(() => import('../pages/dashboard/modules/users/DashboardUsers.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_BENEFICIARIES,
        component: lazy(() => import('../pages/dashboard/modules/beneficiares/Beneficiaries.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_CONTACTS,
        component: lazy(() => import('../pages/dashboard/modules/contacts/Contacts.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_SCHEDULES,
        component: lazy(() => import('../pages/dashboard/modules/schedules/DashboardSchedules.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_TRANSACTIONS,
        component: lazy(
          () => import('../pages/dashboard/modules/transactions/DashboardTransactions.page'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.TRANSACTION_DETAILS,
        component: lazy(() => import('../pages/dashboard/modules/transactions/Transaction.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_EXPENSES,
        component: lazy(() => import('../pages/dashboard/modules/expenses/DashboardExpenses.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_BALANCES,
        component: lazy(() => import('../pages/dashboard/modules/balances/DashboardBalances.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_HISTORY,
        component: lazy(() => import('../pages/dashboard/modules/history/DashboardHistory.page')),
        guards: [],
      },
      // {
      //   path: APP_CONSTANTS.APP_PATHS.DASHBOARD_TARGET,
      //   component: lazy(() => import('../pages/dashboard/modules/target/DashboardTarget.page')),
      //   guards: [],
      // },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_PROFILE,
        component: lazy(() => import('../pages/dashboard/modules/profile/DashboardProfile.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_SETTINGS,
        component: lazy(() => import('../pages/dashboard/modules/settings/Settings.page')),
        guards: [],
      },
      {
        path: '/dashboard/admin/kyc-management',
        component: lazy(() => import('../pages/dashboard/modules/admin/AdminKYCManagement.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_SINGLE_PAYMENT,
        component: lazy(
          () => import('../pages/dashboard/modules/single-payment/SinglePayment.page'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_SINGLE_PAYMENT_SUMMARY,
        component: lazy(
          () =>
            import('../pages/dashboard/modules/single-payment-summary/SinglePaymentSummary.page'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_BULK_PAYMENT,
        component: lazy(() => import('../pages/dashboard/modules/bulk-payment/BulkPayment.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_BULK_PAYMENT_SUMMARY,
        component: lazy(
          () => import('../pages/dashboard/modules/bulk-payment-summary/BulkPaymentSummary.page'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_SETTINGS_ACCOUNT,
        component: lazy(
          () => import('../pages/dashboard/modules/settings/account/AccountSettings.page'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_SETTINGS_WALLET,
        component: lazy(
          () => import('../pages/dashboard/modules/settings/wallet/WalletSettings.page'),
        ),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_SETTINGS_WALLET_ADD,
        component: lazy(() => import('../pages/dashboard/modules/settings/wallet/AddWallet.page')),
        guards: [],
      },
      {
        path: APP_CONSTANTS.APP_PATHS.DASHBOARD_SETTINGS_SECURITY,
        component: lazy(
          () => import('../pages/dashboard/modules/settings/security/SecuritySettings.page'),
        ),
        guards: [],
      },
    ],
  },
]
